export default "__VITE_ASSET__2W_Dwk0G__"